import * as React from 'react';
import { cn } from '@/lib/utils';

const ChatFile = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-file', 'flex p-3 items-center gap-3 rounded-sm border border-solid border-neutral-lightest bg-white mb-2 transition duration-150 shadow-dropshadow-sm hover:shadow-dropshadow-md', className)}
    {...props}
  />
));
ChatFile.displayName = 'ChatFile';

const ChatFileContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-file-content', 'w-10 grow flex flex-col', className)}
    {...props}
  />
));
ChatFileContent.displayName = 'ChatFileContent';

const ChatFileTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-chat-file-title', 'text-primary-dark text-sm font-bold mb-0 truncate', className)}
    {...props}
  />
));
ChatFileTitle.displayName = 'ChatFileTitle';

const ChatFileMeta = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-chat-file-meta', 'text-neutral text-xs mb-0 truncate', className)}
    {...props}
  />
));
ChatFileMeta.displayName = 'ChatFileMeta';

export { ChatFile, ChatFileContent, ChatFileTitle, ChatFileMeta };
